<template>
    <v-dialog v-model="dialog" width="600px">
        <v-card class="pa-3">
            <v-card-title>Add a price update to {{ huis.huis_code }} 
            </v-card-title>
            <v-card-text>
            <v-form ref="addHspa">
                <v-row no-gutters class="mt-4">
                    <v-col cols="6" class="py-2 pr-2">
                        <date_picker label="Arrival from"                                 
                                     :date="hspaFromDate"
                                     :startDate="hspaFromDate"
                                     field="hspaFromDate" 
                                     hint="Only enter a date if applicable" 
                                     icon="mdi-calendar-month-outline"
                                     :manual="true" 
                                     @updateData="updateData"/> 
                    </v-col>
                    <v-col cols="6" class="py-2 pl-2">
                        <date_picker label="Arrival until"                                 
                                     :date="hspaUntilDate"
                                     :startDate="hspaFromDate"
                                     field="hspaUntilDate" 
                                     hint="Only enter a date if applicable" 
                                     icon="mdi-calendar-month-outline"
                                     :manual="true" 
                                     @updateData="updateData"/>                                      
                    </v-col>
                </v-row>
                <v-row no-gutters cols="12">
                    <v-col cols="3" class="pa-2">
                        <v-select 
                            v-model="hspa_aant_nacht_van" 
                            :items="nacht_nrKeuzes"
                            item-value="nacht_nr" 
                            item-text="nacht_oms" 
                            label="Min. Nr. of Nights"
                            dense
                            />
                    </v-col>
                    <v-col cols="3" class="pa-2">
                        <v-select 
                            v-model="hspa_aant_nacht_tm" 
                            :items="nacht_nrKeuzes"
                            item-value="nacht_nr" 
                            item-text="nacht_oms" 
                            label="Max. Nr. of Nights"
                            dense
                            />
                    </v-col>
                </v-row>
                <v-row no-gutters cols="12">
                    <v-col cols="12" class="pa-2">
                        <div>Add a negative number for a discount and a positive number for a price increase.</div> 
                    </v-col>
                    <v-col cols="3" class="pa-2">
                        <v-text-field v-model="huis.hspa_prijs_aanpas_perc" label="" dense suffix="%"></v-text-field>
                    </v-col>
                </v-row>

            </v-form>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn class="primary mx-2" small @click="addHspa">Save</v-btn>
                <v-btn color="primary" small @click="closeDialog()">Close</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

import date_picker from '@/components/ui/date_picker.vue';

export default {

    data() {
        return {
            dialog: false,
            huis_encrid: null,
            nacht_nrKeuzes: [],
            huis: {},
            hspaFromDate: null, 
            hspaUntilDate: null,
            hspa_aant_nacht_van: null,
            hspa_aant_nacht_tm: null,
            showBookingDates: false,
        }
    },
    components: {
        date_picker,
    },
    watch: {
        'huis.hspa_prijs_aanpas_perc': {
            handler(newVal) {
            this.huis.hspa_prijs_aanpas_perc = newVal;
            }
        }
    },
    methods: {
        updateData(data){
            this[data.field] = data.value;
        },
        closeDialog(){
            this.$refs.addHspa.reset();
            this.showBookingDates = false;
            this.$emit("updateData");
            this.dialog = false;
        },
        open(huis_encrid) {

            this.$emit("showSnackbar");        
            this.huis_encrid = huis_encrid
            this.hspaFromDate = null 
            this.hspaUntilDate = null
            this.hspa_aant_nacht_van = 2
            this.hspa_aant_nacht_tm = 28
            this.$axios
                .post("ares/json/ares/huis/hspa/getHuisToAddHspa.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getHuisToAddHspa"
                    },
                    getHuisToAddHspa: {
                        huis_encrid: huis_encrid
                    }
                })
                .then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        this.huis = res.data.getHuisToAddHspa;
                        this.nacht_nrKeuzes = res.data.getHuisToAddHspa.nacht_nrKeuzes;
                    }
                })
                .finally(() => {
                    this.dialog = true;
                });
        },
        addHspa() {
            this.$axios
                .post("ares/json/ares/huis/hspa/addHspa.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "addHspa"
                    },
                    addHspa: {
                        huis_encrid: this.huis.huis_encrid,
                        hspa_verb_van_dat: this.hspaFromDate,
                        hspa_verb_tm_dat: this.hspaUntilDate,
                        hspa_aant_nacht_van: this.hspa_aant_nacht_van,
                        hspa_aant_nacht_tm: this.hspa_aant_nacht_tm,
                        hspa_prijs_aanpas_perc: parseFloat(this.huis.hspa_prijs_aanpas_perc) || 0,
                    }
                })
                .then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        this.$store.dispatch('setSnackbar', {
                            showing: true,
                            text: res.data.addHspa.text,
                            color: res.data.addHspa.color
                        });
                        this.closeDialog();
                    }
                })
        }
    }
}
</script>

